import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { UserActions } from "./profile.actions";
import { filter, map, switchMap, tap } from "rxjs";
import { AuthService } from "projects/shared/services/auth.service";
import { SelectUserStatus } from "./profile.selectors";
import { BrowserService } from "projects/shared/services/browser.service";
import { CartActions } from "projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-cart/store/cart.actions";

@Injectable()
export class UserEffect {
  store = inject(Store);
  actions = inject(Actions);
  authService = inject(AuthService);
  userStatus$ = this.store.selectSignal(SelectUserStatus);
  browser = inject(BrowserService)
  STORAGE_KEY = 'card4games_shop_state'

  getUserEffect$ = createEffect(() => this.actions.pipe(
    ofType(UserActions.userLogin),
    filter(() => !!this.userStatus$()),
    tap(() => { }),
    switchMap(() => this.authService.validate().pipe(
      tap(res => { CartActions.initializeCart({ initialized: true }) }),
      map(res => UserActions.getUser({ data: res }))
    ))
  ));

  userLogoutEffect$ = createEffect(() => this.actions.pipe(
    ofType(UserActions.userLogout),
    switchMap(() => this.authService.logout().pipe(
      map(() => {
        this.browser.getLocalStorage()?.removeItem(this.STORAGE_KEY);
        this.store.dispatch(CartActions.clearCart())
        return UserActions.userLogin({ login: false })
      })
    ))
  ))
}